<div class="container">
    <div class="row justify-content-md-center">
        <div class="col-24 col-md-20 col-xl-16 pt-2">
            <div class="mb-3">
                <h3>Mijn account</h3>
                <div class="row">
                    @if (user) {
                        <div class="col-24">
                            Je bent ingelogd als {{ user.name }}. Je e-mailadres is {{ user.email }}.
                        </div>
                    }
                    <div class="col-24 mt-2">
                        <button (click)="logout()" color="warn" mat-raised-button>Uitloggen</button>
                    </div>
                </div>
            </div>

            @if (Features.AuthMeSettings_moduleKey_Modify | hasFeature) {
                <div class="mb-3">
                    <h3>Notificaties</h3>
                    <div class="row">
                        <div class="col-24">
                            <mat-slide-toggle
                                (change)="projectEmailNotifChanged($event)"
                                [ngModel]="user.settings?.modules?.notifications?.emailNotifications"
                                [ngModelOptions]="{ standalone: true }"
                                color="primary">
                                Dagelijkse e-mailupdate over mijn projecten
                            </mat-slide-toggle>
                        </div>
                    </div>
                </div>
            }

            @if (Functionalities.CustomerProjectsSubscribe | hasFunctionality) {
                <div class="mb-3">
                    <h3>Mijn projecten</h3>
                    <div class="row">
                        <div class="col-24">
                            <p>Je volgt de volgende projecten van D. van der Steen B.V.:</p>
                            <table class="table w-100 mb-3">
                                <tbody>
                                    @for (customerProject of user?.customer_projects; track customerProject) {
                                        <tr>
                                            <td class="customer-project-cell">
                                                {{ customerProject.name }}
                                            </td>
                                            <td class="text-end">
                                                <button
                                                    (click)="removeCustomerProject(customerProject)"
                                                    color="warn"
                                                    mat-stroked-button>
                                                    Uitschrijven<span class="d-none d-md-inline"> voor project</span>
                                                </button>
                                            </td>
                                        </tr>
                                    }
                                    <tr>
                                        <td colspan="2"></td>
                                    </tr>
                                </tbody>
                            </table>
                            <button (click)="addCustomerProject()" class="mb-3" color="primary" mat-stroked-button>
                                Project toevoegen
                            </button>
                        </div>
                    </div>
                </div>
            } @else {
                @if (Functionalities.CustomerProjectsManage | hasFunctionality) {
                    <div class="mb-3">
                        <h3>Admin</h3>
                        <div class="row">
                            <div class="col-24">
                                <button
                                    color="primary"
                                    mat-stroked-button
                                    routerLink="/{{ Routenames.importShapefile }}">
                                    Shapefile importeren
                                </button>
                            </div>
                        </div>
                    </div>
                }

                <div class="mb-3">
                    <h3>Voorkeuren kaart</h3>
                    @for (mapsetting of staticmapsettings; track mapsetting) {
                        <div>
                            <mat-checkbox
                                (change)="mapSettingsChanged()"
                                [(ngModel)]="StaticSettings.mapSettings[mapsetting.key]"
                                [value]="true"
                                color="primary">
                                {{ mapsetting.description }}
                            </mat-checkbox>
                        </div>
                    }
                    <br />
                    <mat-checkbox
                        (change)="mapSettingsChanged()"
                        [(ngModel)]="StaticSettings._mapSettings['largeMapTextShadow']"
                        [value]="false"
                        color="warn">
                        Schaduw achter vaknummers ook tonen bij veel werkvakken
                    </mat-checkbox>
                    <br />
                    <small>
                        Het tonen van schaduw maakt de kaart beter leesbaar maar zorgt ervoor dat de kaart langzamer
                        laadt
                    </small>
                </div>
            }

            @if (Functionalities.Wfs | hasFunctionality) {
                <app-settings-wfs />
            }

            <app-auth-sessions />
        </div>
        <div class="col-24 col-md-20 col-xl-16">
            <div class="moredetails">
                <h3>App details</h3>
                <p>Huidige versie: {{ version.version }}</p>
                <p>Versie datum: {{ version.datetime | date: "d MMMM y 'om' HH:mm" }}</p>

                <a class="codalt" href="https://codalt.com?utm_source=dvds_dirk" target="_BLANK">
                    <div>Via</div>
                    <img alt="Codalt" src="assets/images/codalt.svg" />
                </a>
            </div>
        </div>
    </div>
</div>
